import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IFilter } from '../../interfaces/ifilter';

import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';
import { IFilterModel } from '../../models/filter-model';


@Component({
  selector: 'split-filter-option',
  templateUrl: './split-filter-option.component.html',
  styleUrls: ['./split-filter-option.component.scss']
})
export class SplitFilterOptionComponent {
  @Input() data!: any[];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;

  @Input() id!: string;

  protected _selected!: any;

  @Input() public selected!: any; 
  @Output() public selectedChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() public groupId!: any; 

  protected filterModel!: IFilterModel;

  public required: boolean = true;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();
  @Output() onSearchEvent: EventEmitter<IFilter[]> = new EventEmitter<IFilter[]>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;



  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((event: IFilterSubject) => event.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId),
      filter((event: IFilterSubject) =>  this.required == false)
    ).subscribe((event: IFilterSubject) => {
      this._selected = null;
      this.onEmit();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["selected"]) {
      this._selected = this.copy();
    }  

    if(changes["key"]) {
      this.filterModel = {
        id: this.groupId,
        type: "FILTER",
        key: this.key,
        data: this._selected,
        component: this,
        filter: [{
          property: this.field,
          value: this._selected.id,
          key: this.key,
        }]
      }
    }
  }

  copy() {
    return this.selected;
  }

  showOverlayPanel(event: any) {
    this._selected = this.copy();
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._selected = null;
    this.isActiveOverlay = false;
  }

  onChange(event: any, position: number) {
    console.log(event);
    //this._data[position].checked = event.checked;
  }

  onSearch(event: any) {
    console.log(event);
    let filter: IFilter = {
      property: "search",
      fields: [this.field],
      value: event,
      key: this.key + "Search"
    }
    this.onSearchEvent.emit([filter]);
  }

  onEmit() { 
    console.log(this.selected);
    console.log(this._selected);
    /*let dataChecked = this._selected.filter(item => item.checked);*/
    let filter: IFilter[] = [];

    if(this._selected) {
      filter = [{
        property: this.field,
        value: this._selected.id,
        key: this.key,
      }]; 
    }
    

    let filterModel: IFilterModel = {
      ...this.filterModel,
      data: [this._selected],
      filter: filter
    }

    //this.filterService.set(this.id, this.field, this.key, "FILTER", dataChecked as IFilterData[])

    this.selected = this._selected;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    this.selectedChange.emit(this._selected);
    this.overlayPanel.hide();
  }
}
